const o=75,t=500;export{t as MAX_SESSION_DESCRIPTION,o as MAX_SESSION_TITLE};
